import React from "react";

function DashboardNav() {
    return (
        <>
            <div className="dashboard_nav">
                <div className="dashboard_nav_logo">
                    <a href="/dashboard">
                        <img src={require ('../../assets/images/logo_icon.png')} alt="logo" />
                    </a>
                </div>
            </div>
        </>
    );
}

export default DashboardNav;